import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useToast } from "../hooks/use-toast";
import logo from "../assets/logo.png";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || form.password.length < 6) {
      toast({ title: "Please enter a name, email and 6+ char password", variant: "destructive" });
      return;
    }
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.error) { toast({ title: res.error, variant: "destructive" }); return; }
    toast({ title: `Welcome, ${(res.user.name || "there").split(" ")[0]}!` });
    navigate("/");
  };

  return (
    <div className="min-h-screen hero-dark grid place-items-center px-5 py-20">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-8">
        <div className="flex items-center gap-2 justify-center mb-6">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-white border border-slate-100 overflow-hidden"><img src={logo} alt="Flycher Travels" className="w-full h-full object-contain p-0.5" /></span>
          <span className="font-display font-bold text-lg text-slate-900">Flycher Travels</span>
        </div>
        <h1 className="text-2xl font-bold text-slate-900 text-center">Create your account</h1>
        <p className="text-sm text-slate-500 text-center mt-1">Book curated group tours in minutes.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><Label>Full Name</Label><Input value={form.name} onChange={set("name")} className="mt-1" placeholder="Your name" /></div>
          <div><Label>Email</Label><Input value={form.email} onChange={set("email")} type="email" className="mt-1" placeholder="you@email.com" /></div>
          <div><Label>Password</Label><Input value={form.password} onChange={set("password")} type="password" className="mt-1" placeholder="Min 6 characters" /></div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-coral-600 hover:bg-coral-700 text-white">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign up"}
          </Button>
        </form>
        <p className="mt-5 text-center text-sm text-slate-500">
          Already have an account? <Link to="/login" className="text-coral-600 font-semibold">Log in</Link>
        </p>
      </div>
    </div>
  );
}
